module.exports = __webpack_public_path__ + "static/media/logo.c52ec216.png";